import { fetchExamData, parseExamCatalog } from './dataApi';

function normalizedLanguage(language) {
  const code = String(language || '').trim().toLowerCase();
  return /^[a-z]{2,3}$/.test(code) ? code : null;
}

export function dailyTestsFromIndex(index) {
  // The exam tree is now catalog.json (an { index1: { path: 'examN.json' } }
  // object), not a rich index.json array — normalise the object form to the
  // minimal { id, day, file } rows this function already understands. A pack's
  // theme/question-count/xp live inside the pack itself, not the catalog, so
  // those stay at their defaults here (the home card only needs the count).
  if (index && !Array.isArray(index) && typeof index === 'object') {
    return dailyTestsFromIndex(
      parseExamCatalog(index).map(({ packId, rootFile }, i) => ({
        id: packId,
        day: i + 1,
        file: rootFile,
      })),
    );
  }
  if (!Array.isArray(index)) return [];

  return index
    .filter((test) => {
      const day = Number(test?.day ?? test?.id);
      return Number.isInteger(day) && day > 0 && typeof test?.file === 'string';
    })
    .map((test) => ({
      id: String(test.id ?? test.day),
      day: Number(test.day ?? test.id),
      file: test.file,
      theme: String(test.theme || `Day ${test.day ?? test.id}`),
      focus: String(test.focus || ''),
      level: String(test.level || ''),
      questionCount: Number(test.numberOfQuestions) || 0,
      xp: Number(test.xp) || 0,
    }))
    .sort((first, second) => first.day - second.day);
}

// data-exam is duplicated identically into all 4 data-topic-lessons homes
// (unlike skill-path, it isn't sliced per-home), so any target language —
// including the ~36 beyond the 4 skill-path curricula — resolves the same
// way through the default home.
export async function loadDailyTestsCatalog(language, options) {
  const code = normalizedLanguage(language);
  if (!code) return [];
  const catalog = await fetchExamData(undefined, `${code}/catalog.json`, options);
  return dailyTestsFromIndex(catalog);
}
